import { ref, onBeforeUnmount } from 'vue';
import { EVENTS } from '../../config/component-lib.esm.js';

/**
 * Track a videos watch time
 * @param {Function} callback
 * @param {Object} options
 * @returns An object with a `track` and `stop` method
 */
function useVideoWatchTracking(callback, options) {
  const {
    getDuration,
    getCurrentTime,
    interval = 2000,
    trackPlaying = true
  } = options;
  const timeout = ref(null);
  const trackedWatchEvents = ref([]);
  const videoDuration = ref(0);
  function trackWatchEvent(event) {
    if (!trackedWatchEvents.value.includes(event)) {
      callback(event);
      trackedWatchEvents.value.push(event);
    }
  }
  async function getVideoDuration() {
    if (videoDuration.value) return videoDuration.value;
    const duration = await getDuration();
    videoDuration.value = duration;
    return duration;
  }
  async function trackPlayState() {
    clearTimeout(timeout.value);
    const duration = await getVideoDuration();
    if (duration > 0) {
      const currentTime = await getCurrentTime();
      const percentComplete = currentTime / duration * 100;
      if (trackPlaying) callback(EVENTS.VIDEO_PLAYING);
      if (percentComplete >= 25) trackWatchEvent(EVENTS.VIDEO_25_PERCENT_WATCHED);
      if (percentComplete >= 50) trackWatchEvent(EVENTS.VIDEO_50_PERCENT_WATCHED);
      if (percentComplete >= 75) trackWatchEvent(EVENTS.VIDEO_75_PERCENT_WATCHED);
    }
    timeout.value = setTimeout(trackPlayState, interval);
  }
  function stopTrackingPlayState() {
    clearTimeout(timeout.value);
  }
  onBeforeUnmount(() => stopTrackingPlayState());
  return {
    track: trackPlayState,
    stop: stopTrackingPlayState
  };
}
export { useVideoWatchTracking };